// @flow

import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import Slider from 'fg-frontend/components/Slider';
import NumberInput from 'fg-frontend/components/NumberInput';
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
import ListToggle from 'fg-frontend/components/ListToggle';
import Typeahead from 'fg-frontend/components/Typeahead';
import FulltextAutocomplete from 'fg-frontend/components/FulltextAutocomplete';
import PasswordToggle from 'fg-frontend/components/PasswordToggle';
import AnchorsList from 'fg-frontend/src/components/AnchorsList';
import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
import SocialShare from 'fg-frontend/components/SocialShare';

import AddSvgIconSprite from './components/AddSvgIconSprite';
import SelectDesign from './components/SelectDesign';
import Tooltip from './components/Tooltip';
// import GoogleMapCareer from './components/GoogleMapCareer';
import GtmHandler from './components/GtmHandler';
import LazyImage from './components/LazyImage';
import CustomGtmHandler from './components/CustomGtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
//import VacanciesList from './components/VacanciesList';
import StageCheckboxSelect from './components/StageCheckboxSelect';

// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
import GoogleRecaptcha from 'fg-frontend/src/components/GoogleRecaptcha';

export default (props) => {
    switch (props.decorator || props.is) {
        case 'AddSvgIconSprite':
            return AddSvgIconSprite;
        case 'RadioSelect':
        case 'CheckboxSelect':
            return RadioSelect;
        case 'SimpleCollapse':
            return SimpleCollapse;
        case 'Typeahead':
            return Typeahead;
        case 'SelectDesign':
            return SelectDesign;
        case 'ListToggle':
            return ListToggle;
        case 'PasswordToggle':
            return PasswordToggle;
        case 'SocialShare':
            return SocialShare;
        case 'AnchorsList':
            return AnchorsList;
        case 'FulltextAutocomplete':
            return FulltextAutocomplete;
        case 'Slider':
            return Slider;
        case 'RadioSelectTab':
            return RadioSelectTab;
        case 'NumberInput':
            return NumberInput;
        case 'UniversalPaginationButton':
            return UniversalPaginationButton;
        case 'Tooltip':
            return Tooltip;
        // case 'GoogleMapCareer':
        //     return GoogleMapCareer;
        case 'GtmHandler':
            return GtmHandler;
        case 'CustomGtmHandler':
            return CustomGtmHandler;
        case 'LazyImage':
            return LazyImage;
        case 'PhotoSwipe':
            return import('./components/PhotoSwipe');
        case 'TriggerInViewport':
            return TriggerInViewport;
        /*case 'VacanciesList':
            return VacanciesList;*/
		case 'StageCheckboxSelect':
			return StageCheckboxSelect;
        case 'GoogleRecaptcha':
            return GoogleRecaptcha;
        case 'ZigZagWithExtendedContent':
            return import('./components/ZigZagWithExtendedContent');
        case 'Faq':
            return import('./components/Faq');
        case 'EcologySlider':
            return import('./components/EcologySlider');
        default:
            console.log(`Unknown component ${props.decorator || props.is}`);
            return null;
    }
};



// WEBPACK FOOTER //
// ./fe/web-career/src/js/configureWebComponents.js